var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatchT(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 91,
    viewBox: "0 0 128 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.198 48.7864C114.321 51.5156 109.581 53.3362 104.556 54.7109C76.8545 62.2889 41.284 65.2729 15.7252 50.5575C4.93997 44.3485 -1.02965 33.7754 0.146521 22.2213C1.29416 10.9604 8.34485 5.52312 20.2334 3.73877C46.8922 -0.26295 75.8273 -1.34971 102.645 1.94274C108.446 2.65484 114.482 3.77598 118.972 7.16966C123.052 10.2549 125.353 14.876 126.663 19.5343C128.505 26.0681 128.609 33.1365 125.93 39.4294C124.231 43.4175 121.533 46.4384 118.198 48.7864Z",
    fill: "#C1DFEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3362 40.7767C9.41747 41.6633 6.5627 45.2376 5.54656 49.0663C1.06962 65.9215 25.1113 89.4636 40.5972 90.9121C59.4277 92.6738 68.9506 67.4595 72.7964 49.6326C74.2933 42.6973 71.5023 34.3106 64.7766 31.7651C58.7504 29.484 51.8516 32.6067 47.3154 37.1273C45.1555 39.2777 43.2714 41.7887 40.6057 43.2925C37.4684 45.0643 33.5907 45.1986 30.0615 44.4139C28.8176 44.137 27.6169 43.7431 26.4367 43.3102C22.1785 41.7481 18.1891 39.6786 13.3362 40.7767Z",
    fill: "#F18273"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1628 85.8734C31.6604 88.6941 36.2252 90.5383 40.2205 90.9121C59.051 92.6737 68.5738 67.4594 72.4197 49.6325C73.4322 44.9413 72.4828 39.5861 69.6809 35.8237C69.6576 36.0017 69.6341 36.1825 69.6106 36.366C65.3542 69.5493 35.2073 82.8833 27.1628 85.8734Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchT);
export default __webpack_public_path__ + "static/media/matchT.bdbb78d9bf7039861da565a277050e7f.svg";
export { ForwardRef as ReactComponent };